import { Reporter, visibilityObserver } from 'features/dataCapture';
import { setProductClick, trackWishlistActions, trackInlineRenameValidation } from 'features/tealium';
import { utagLinkSelectItem } from 'features/tealium/ga4/ecommerce';
import { delegateEvent, domReady } from 'utilities/dom';
import { isSafariUserAgent, supportsSessionStorage } from 'utilities/browser';
import { trackDyRecommendedItemClickEvent } from 'features/tealium/dynamicYield/recommendedItemsTracking';

import app from './backboneApp/app';
import loadWishListItems from './backboneApp/loadWishListItems';
import showOpenWishListModal from './backboneApp/showOpenWishListModal';

const { reporter } = window.lp.dataCapture;
$(() => {

	// intercept wishlist api response to perform some stale page checks
	$.ajaxPrefilter((options) => {

		let origSuccess;
		if (!/get/i.test(options.type) && options.url.indexOf('/api/globalwishlists/') !== -1) {

			origSuccess = options.success;
			options.success = function (response, textStatus, xhr) {

				const rawResponse = _.deepClone(response);

				if (response) {

					// response is altered in Wishlist inline rename functionality but original response is preserved
					if (response.originalResponse) {

						response = response.originalResponse;

					}

					// redirect to stale error page if wishlist id or item id is invalid
					if (
						response.ErrorMessage === 'FailureInvalidWishListId'
						|| response.ErrorMessage === 'FailureInvalidItemId'
					) {

						window.top.location.replace('/Error/ConcurrentErrorPage/');
						return;

					}

					// update current token with the new one
					if (response.CurrentWishListToken) {

						if (lp.wishlist.wishlistToken !== response.CurrentWishListToken) {

							lp.wishlist.wishlistToken = response.CurrentWishListToken;
							$('<div id="loadingWrapper"></div>').prependTo('body').fadeTo(700, 0.7);
							loadWishListItems($('.wishlistView').attr('id'), () => {

								$('#loadingWrapper').fadeOut(300, function () {

									$(this).remove();

								});

							});

						}

					}

				}

				// call original success callback
				origSuccess.call(this, rawResponse, textStatus, xhr);

			};

		}

	});

	// Add list type tracking via sessionStorage
	if (supportsSessionStorage()) {

		document.body.addEventListener(
			'click',
			delegateEvent(() => {

				sessionStorage.setItem('listType', 'Wish List');

			}, '.wishlistItemName, .lnkAddToCart, .btnBuy')
		);

	}

	// trigger load wishlist
	$(lp.wishlist).on('loadWishListItems', (e, viewType, callback) => {

		loadWishListItems(viewType, callback);

	});

	$('.wishlistQty').inputFilter({ type: 'integer' });

	function initializeDataCapture () {

		const elementObserver = visibilityObserver((element) => {

			const data = Reporter.getSkuViewData(element);
			reporter.track(data);

		});

		document.addEventListener('recommendedItems:loaded', () => {

			const mymlElements = document.querySelectorAll(
				'[data-capture-section="MoreYouMayLikeWidget"] img[data-sku]'
			);
			mymlElements.forEach((element) => elementObserver.observe(element));

			const moreYouMayLikeWidget = document.querySelectorAll('[data-capture-section="MoreYouMayLikeWidget"] a');
			if (moreYouMayLikeWidget.length) {

				trackDyRecommendedItemClickEvent({ selector: moreYouMayLikeWidget });

			}

		});

	}

	if (window.lp.globals.enableDataCapture) {

		initializeDataCapture();

	}

	// true for Delegated click event
	setProductClick('Wish List', null, true);
	// GA4 ecommerce set_item event
	document.body.addEventListener(
		'click',
		delegateEvent((e) => {

			const captureElement = e.target.dataset.gaCaptureItem
				? e.target
				: e.target.closest('[data-ga-capture-item]');

			if (captureElement) {

				utagLinkSelectItem({
					sku: captureElement.dataset.sku,
					name: captureElement.dataset.name,
					price: captureElement.dataset.price,
					skuInputType: captureElement.dataset.skuInputType,
					primaryCategory: captureElement.dataset.primaryCategory,
					productNewItemDate: captureElement.dataset.productNewItemDate
				});

			}

		}, '[data-ga-capture-item]')
	);

	// register open wishlist click from empty (default) view
	const emptyViewOpenWishlistBtn = document.getElementById('emptyViewOpenWishlistBtn');
	if (emptyViewOpenWishlistBtn) {

		emptyViewOpenWishlistBtn.addEventListener('click', () => {

			showOpenWishListModal({ isDefaultView: true });

		});

	}

	// track continue shopping click from default view
	const defaultViewShoppingLink = document.querySelector('.defaultWlContinueShopping');
	if (defaultViewShoppingLink) {

		// eslint-disable-next-line max-len
		defaultViewShoppingLink.addEventListener('click', () => trackWishlistActions({ eventAction: 'Click-Continue-Shopping' }));

	}

	window.addEventListener('load', () => {

		// track which default (empty) view loaded
		if (document.body.classList.contains('nosavedlist')) {

			trackWishlistActions({
				eventAction: 'Load-NoSavedList',
				nonInteraction: 1
			});

		} else if (document.body.classList.contains('noopenwishlist')) {

			trackWishlistActions({
				eventAction: 'Load-NoOpenWishlist',
				nonInteraction: 1
			});

		}

		if (window.lp.wishlist.printMode) {

			const printWishlist = function () {

				window.print();

				// If on safari, after printing once we don't want to auto-close the modal.
				// This is b/c safari pops up a modal after 1st print saying automatic printing has been blocked.
				// This results in the lpModal already being auto-closed by the time you click "Allow", prints blank.
				if (isSafariUserAgent()) {

					return;

				}

				setTimeout(() => {

					window.parent.$('body').lpModalClose();

				}, 0);

			};

			if (window.lp.globals.canShowCertona && lp.utils.certonaAjax) {

				lp.utils.certonaAjax.done(() => {

					lp.utils.checkImageComplete({
						images: $('.suggestedProductsContainer:visible li:first-child img'), // only images for first slide
						callback: printWishlist
					});

				});

			} else {

				printWishlist();

			}

		}

	});

	const inlineRenameErrorEl = document.querySelector('.wishlistHeaderNameError .validationError');
	trackInlineRenameValidation(inlineRenameErrorEl);

	app.start();

	if (window.lp.globals.canShowCertona) {

		window.lp.certona.getRecommendedItems();

	}

});

domReady(() => {

	if (window.lp.wishlist.printMode) {

		const lpModal = window.parent.document.getElementById('lpModal');
		if (lpModal) lpModal.classList.remove('hideWishListPrint');

		window.parent.$('body').lpModalResize({
			width: window.innerWidth < 992 ? 992 : window.innerWidth,
			height: 640
		});

	} else {

		const wishlistHeaderName = document.querySelector('#wishlistHeaderName');
		const wishlistHeader = document.querySelector('#wishlistHeader');
		if (wishlistHeader && wishlistHeaderName) {

			const observer = new MutationObserver(() => {

				if (wishlistHeaderName.innerText) {

					wishlistHeader.classList.add('withContent');

				} else {

					wishlistHeader.classList.remove('withContent');

				}

			});

			observer.observe(wishlistHeaderName, {
				attributes: true,
				childList: true,
				characterData: true
			});

		}

	}

});
